import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * "Lihat semua" — the affordance that makes a summary panel honest.
 *
 * Every dashboard panel shows a top-N of something that has a full screen
 * elsewhere. Without a visible route to that screen the truncation is a lie by
 * omission; with one, "5 Outlet dengan skor terendah" is a legitimate summary.
 *
 * `text-primary-700` is the one primary that may carry text — 5.53:1 on white.
 * `primary` itself is 3.08:1 and would fail AA at this size (§1.2).
 */
export function PanelLink({ to, label = 'Lihat semua' }: { to: string; label?: string }) {
  return (
    <Link
      to={to}
      className="focus-ring inline-flex h-control-sm shrink-0 items-center gap-1 rounded-lg px-2 text-sm font-semibold text-primary-700 transition-colors duration-150 hover:bg-tint"
    >
      {label}
      <ArrowRight size={14} aria-hidden />
    </Link>
  );
}
